<template>
    <div>
        <card-header title="Course Components" icon="fa-cubes"/>

        <card-toolbar>
            <button @click="$openCard('new-component', {}, card)"><i class="far fa-plus"></i>New Component</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <search-list-item @action="search"/>

                <container-list-item class="pl-4 pr-4 pb-4">
                    <b-field>
                        <b-taginput
                            ref="taginput_newComp"
                            v-model="searchTags"
                            ellipsis
                            :data="filteredTags"
                            @typing="getFilteredTags"
                            icon="fa fa-tag"
                            placeholder="Search tags..."
                            aria-close-label="Delete this tag"
                            :allow-new="false"
                            :autocomplete="true"
                        >
                            <template slot-scope="props">
                                {{ props.option.tag }}
                            </template>
                            <template #empty>
                                No tags found.
                            </template>
                            <template #selected="props">
                                <b-tag
                                    v-for="(tag, index) in props.tags"
                                    :key="index"
                                    rounded
                                    :tabstop="false"
                                    ellipsis
                                    closable
                                    @close="$refs.taginput_newComp.removeTag(index, $event)">
                                    {{ tag.tag }}
                                </b-tag>
                            </template>
                        </b-taginput>

                    </b-field>
                </container-list-item>


                <separator-list-item/>
                <component-tile
                    :card="card"
                    :component="c"
                    v-for="c in components"
                    @click="$openCard('component-editor', {componentId: c.id}, card)"
                    :active="child && child.definition.component === 'component-editor' && child.props.componentId == c.id"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import {client as http} from "@/http_client";
    import ComponentTile from "@/components/tiles/ComponentTile";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    export default {
        components: {ContainerListItem, ComponentTile, CardToolbar, SeparatorListItem, NavigationListItem, CardHeader, CardBody, CardList, SubheaderListItem, SearchListItem},
        props: ['card', 'child'],
        data() {
            return {
                components: [],
                searchTags: [],
                tags: [],
                filteredTags: [],
                q: ''
            };
        },
        methods: {
            loadComponents: function(force) {
                this.$emit('loading', true);
                http.get('components/', {params: {q: this.q, tags: this.searchTags.map(s => s.id).join(',')}, force}).then(response => {
                    this.components = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            getFilteredTags(text) {
                this.filteredTags = this.tags.filter((option) => {
                    return option.tag
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0;
                });
            },
            search: function(q) {
                this.q = (q) ? q : '';
                this.loadComponents(true);
            },
            reload: function() {
                this.loadComponents(true);
            }
        },
        watch: {
            'searchTags': function() {
                this.loadComponents(true);
            }
        },
        mounted: function() {
            this.$emit('loading', true);

            this.loadComponents();

            http.get('component-tags/', {force: true}).then(response => {
                // this.tags = response.data.map(t => t.tag);
                this.tags = response.data;
            }).catch(err => {
                this.tags = [];
            });
        }
    };
</script>

<style lang="scss" scoped>

</style>
